import type { FC, PropsWithChildren } from 'react';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <main
      data-testid="layout"
      className="grow overflow-auto bg-gradient bg-[100%,auto] bg-no-repeat p-xl bg-level-01/full"
    >
      {children}
    </main>
  );
};

Layout.displayName = 'Layout';

export { Layout };
